import React from "react";
import { AuthContext, UserManager } from 'oidc-react';
import { AuthContextProps } from "oidc-react";

const now = Math.floor(Date.now() / 1000);

// create fake user
const fakeUser: {
  profile: {
    sub: string;
    aud: string;
    name: string;
    iss: string;
    preferred_username: string;
    exp: number;
    iat: number;
    email: string
  };
  id_token: string;
  token_type: string;
  access_token: string;
  refresh_token: string;
  expired: boolean;
  expires_at: number;
  toStorageString: () => string;
  url_state: string;
  scope: string;
  state: null;
  scopes: string[];
  session_state: string;
  expires_in: number
} = {
  id_token: "fake-id-token",
  session_state: "fake-session",
  access_token: "fake-access-token",
  refresh_token: "fake-refresh-token",
  token_type: "Bearer",
  scope: "openid profile email",
  expires_in: 3600,
  expired: false,
  expires_at: now + 3600,
  profile: {
    sub: "1234567890",
    name: "Bypass User",
    email: "bypass@example.com",
    preferred_username: "bypassuser",
    aud: "your-client-id",
    exp: now + 3600,
    iat: now,
    iss: "https://fake-issuer.com",
  },
  state: null,
  toStorageString: () => "",
  scopes: ["openid", "profile", "email"],
  url_state: "fake-url-state",
};

const fakeAuthContext: AuthContextProps = {
  userData: fakeUser,
  signIn: async () => {},
  signInPopup: async () => {},
  signOut: async () => {},
  signOutRedirect: async () => {},
  isLoading: false,
  userManager: undefined as unknown as UserManager,
};

export const BypassAuthProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <AuthContext.Provider value={fakeAuthContext}>
      {children}
    </AuthContext.Provider>
  );
};
